import BigNumber from 'bignumber.js';
import { Serialize, Numeric } from 'eosjs';
import QRCode from 'qrcode'
import moment from 'moment'
import Amax from '@amax/amaxjs';
const { format } = Amax.modules;

/**
 * 帐号转bigNumber
 * @param {*} accountName
 * @returns
 */
export const nameToNumeric = accountName =>
    format.encodeName(accountName, false);

export const $BigNumber = (val:string | number = 1) => {
    return new BigNumber(val);
};

export const $shiftedBy = (data: number, acc:number) => {
    if(!data) return 0
    acc = Number(acc)
    return $BigNumber(data).shiftedBy(acc);
};

export const $toFixed = (data:any, acc:number): any => {
    if((!data && data !== 0) || String(data).indexOf('--') !== -1) return ''
    return $BigNumber(data).toFixed(acc, 1);
};
export const $toFixedFormat = (data:any, acc:number) => {
    if((!data && data !== 0) || String(data).indexOf('--') !== -1) return '0'
    return Number($BigNumber(data).toFixed(acc, 1));
};

// input val filter   e: React.FormEvent<HTMLInputElement>
export const $filterNumber = (e: any, decimal?: number) => {
    function clearNoNum(val:any) {
        // 先把非数字的都替换掉，除了数字和.
        val = val.replace(/[^\d.]/g, '');

        // 保证只有出现一个.而没有多个.
        val = val.replace(/\.{2,}/g, '.');

        // 必须保证第一个为数字而不是.
        val = val.replace(/^\./g, '');

        // 保证.只出现一次，而不能出现两次以上
        val = val.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
        return val
    }
    // return clearNoNum(value);
    e.target.value = clearNoNum(e.target.value);
    // setval && setval(clearNoNum(e.currentTarget.value))
}

export const $filterNumberDecimal = (value: string, decimal?: number) => {
    function clearNoNum(val:any) {
        // 先把非数字的都替换掉，除了数字和.
        val = val.replace(/[^\d.]/g, '');

        // 保证只有出现一个.而没有多个.
        val = val.replace(/\.{2,}/g, '.');

        // 必须保证第一个为数字而不是.
        val = val.replace(/^\./g, '');

        // 保证.只出现一次，而不能出现两次以上
        val = val.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
        const _last = val.split('.')
        if(decimal && _last[1]){
            return `${_last[0]}.${_last[1].substring(0,decimal)}`
        }else{
            return val
        }

    }
    return clearNoNum(value);
}

export const $numFormat = (val:string | number, flag:boolean = true) => {
    if( !val || !flag) return val;
    let reg = /(\d)(?=(?:\d{3})+$)/g;
    const strAry = val.toString().split('.')
    return `${strAry[0].replace(reg, '$1,')}${strAry.length > 1 ? "."+strAry[1] : ''}`
}

export const $dateFormat = (date:string | undefined, format:string = 'MM-dd hh:mm') => {
    if(!date) return '';
    return (new Date(date) as any).format(format)
}

export const $gt = (val:string | number, next:string | number) => {
    return new BigNumber(val).gt(next)
}

export const $lt = (val:string | number, next:string | number) => {
    return new BigNumber(val).lt(next)
}

export const $plus = (aryNumber: Array<string | number>, decimal: number = 2): number => {
    const sum:any = aryNumber.reduce((acc, cur) => {
        return (new BigNumber(isNaN(acc as any) ? 0 : acc) as any).plus(isNaN((cur as any)) ? 0 : cur);
    })
    return Number(sum.toFixed(decimal, 1))
}

export const $minus = (m1:string | number, m2:string | number, decimal: number = 2): number => {
    const diff:any = new BigNumber(m1).minus(m2)
    return Number(diff.toFixed(decimal, 1))
}

export const $inputNumber = (): string => {
    return window.innerWidth < 960 ? 'number' : 'text';
}

export const $moreLessThan =(value:string | number, acc = 4) => {
    const val = $BigNumber(value);
    return !val.isZero() && val.isLessThan(0.0001)
        ? '< 0.0001'
        : val.isNaN()
            ? value
            : Number(val.toFormat(acc));
}


export const $hash = (txHash:any, length: number = 4, lastLength?: number) => {
    if (!txHash) {
        return '--';
    }
    if(!lastLength) lastLength = length
    return (
        txHash.substring(0, length) +
        '...' +
        txHash.substring(txHash.length - lastLength, txHash.length)
    );
}

// export const scalName = (accountName: string | number): string[] => {
//     accountName = 'planowner3';
//     let str:any = accountName;
//     if(typeof(accountName) === "string"){
//         const sb = new Serialize.SerialBuffer({
//             textEncoder: new window.TextEncoder(),
//             textDecoder: new window.TextDecoder(),
//         });

//         sb.pushName(accountName);
//         str = Numeric.binaryToDecimal(sb.getUint8Array(8));
//     }

//     const min:any = BigInt(str * 2 ** 64).toString(10)
//     const max = BigInt(min).add(2 ** 64).subtract(1).toString(10)

//     console.log('===', str, min, max, str * 2 ** 64)
//     return [min, max]
// };

export const scalName = (accountName: string | number): string[] => {
    // accountName = 'planowner3';
    let str:any = accountName;
    if(typeof(accountName) === "string"){
        const sb = new Serialize.SerialBuffer({
            textEncoder: new window.TextEncoder(),
            textDecoder: new window.TextDecoder(),
        });

        sb.pushName(accountName);
        str = Numeric.binaryToDecimal(sb.getUint8Array(8));
    }

    const pow = $BigNumber(2).pow(64).toFixed();
    const min:any = $BigNumber(str).multipliedBy($BigNumber(2).pow(64).toFixed()).toString(10)
    const max = $BigNumber(min).plus(pow).minus(1).toFixed()

    return [min, max]
};


export const randomName = (): string => {
    const collection = [1,2,3,4,5,'q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', 'a', 's', 'd', 'f', 'f', 'g', 'h', 'j', 'k', 'l', 'z', 'x', 'c', 'v', 'b', 'n', 'm']
    let i = 0, str = '';
    function getRandomInt(min,max){
        return Math.floor(Math.random()*(max-min+1))+min;
    }
    for(i;i<12;i++){
       const index = getRandomInt(0,31);
       str=`${str}${collection[index]}`
    }
    return str
};

export const scalName1 = (accountName: string | number): string[] => {
    // accountName = 'planowner3';
    let str:any = accountName;
    if(typeof(accountName) === "string"){
        const sb = new Serialize.SerialBuffer({
            textEncoder: new window.TextEncoder(),
            textDecoder: new window.TextDecoder(),
        });

        sb.pushName(accountName);
        str = Numeric.binaryToDecimal(sb.getUint8Array(8));
    }
    return [str]
};


export const $utctimeToLocaltime = (time:string) =>{
    let utcTime = time.replace(' ', 'T')+'Z';
    let newDate:any = new Date(utcTime);
    return newDate.format('yyyy-MM-dd hh:mm:ss')

}

export const getQRCode = async(text:string,callback:Function) =>{
  const qrCodeImgUrl = await QRCode.toDataURL(text,{errorCorrectionLevel:'L',margin:1},(err,url)=>{
    callback(err,url)
  })
  return qrCodeImgUrl
}

export const getChinese = (text:string) =>{
    if (text.includes('Voter can only vote or subvote once a day')) {
        return '请在上次改票/撤票24小时后操作'
    }
    if (text.includes('This account already has a vote refund')) {
        return '上轮撤票后的72小时内不可以撤票'
    }
    if (text.includes('producers no change')) {
        return '列表未发生变更'
    }
    if (text.includes('votes must be positive')) {
        return '未进行投票'
    }
    if (text.includes('no rewards to claim')) {
        return '领取失败'
    }
    if (text.includes('overdrawn balance')) {
        return '余额不足'
    }
    return ''
}

export const handleTime = (timestamp?: any) => {
    if (timestamp) {
      return moment.utc(timestamp).local().format('YYYY-MM-DD HH:mm')
    }
};

export const getTimeStamp = (timestamp?: any) => {
    if (timestamp) {
      return moment.utc(timestamp).valueOf();
    }
};


//arr：数组对象，key：对象的某一项
export const maxArrObj = (arr,key) => {
    return Math.max.apply(Math, arr.map(function(o) {return o[key].recv_votes}));
}

export const handlerDateDuration = (time:any)=> {
    const d1 = new Date(time)
    const d2 = new Date()
  
    const cha:number = Math.abs(d2.getTime() - moment.utc(time).local().valueOf())
    const dateBefore = d2.getTime() - moment.utc(time).local().valueOf() > 0 ? '-' : ''
    const days = parseInt(`${cha / (24 * 60 * 60 * 1000)}`)
    const hours = parseInt(`${cha % (24 * 60 * 60 * 1000) / (60 * 60 * 1000)}`) > 9 ? parseInt(`${cha % (24 * 60 * 60 * 1000) / (60 * 60 * 1000)}`) : `0${parseInt(`${cha % (24 * 60 * 60 * 1000) / (60 * 60 * 1000)}`)}`
    const mins =  parseInt(`${cha % (60 * 60 * 1000) / (60 * 1000)}`) > 9 ? parseInt(`${cha % (60 * 60 * 1000) / (60 * 1000)}`) : `0${parseInt(`${cha % (60 * 60 * 1000) / (60 * 1000)}`)}`
    const secs =  parseInt(`${cha % (60 * 1000) / (1000)}`) > 9 ? parseInt(`${cha % (60 * 1000) / (1000)}`) : `0${parseInt(`${cha % (60 * 1000) / (1000)}`)}`
    if (dateBefore === '-') {
        return '0'
    }
    if (days) {
      return `${dateBefore}${days}d ${hours}:${mins}:${secs}`
    } else if (hours) {
      return `${dateBefore}${hours}:${mins}:${secs}`
    } else {
      return `${dateBefore}${mins}:${secs}`
    }
  }

  //截取两个字符中间的字符串
export const extractSubstring = (str:string, start:string, end:string) => {
    var startIndex = str.indexOf(start) + start.length;
    var endIndex = str.indexOf(end, startIndex);
    if (startIndex >= 0 && endIndex > startIndex) {
      return str.substring(startIndex, endIndex);
    } else {
      return '';
    }
}

export const countFiveYears = (timestamp?: any) => {
    if (timestamp) {
       const _arr = moment.utc(timestamp).local().format('YYYY-MM-DD HH:mm').split('-')
       _arr[0] = `${+_arr[0] + 5}`
      return _arr.join('-')
    }
};